import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getClassroomDetails } from '../../api/class';
import { ClassPeople, ClassAssignments, ClassMeets, ClassMessages } from '../../components';
import './MyClassroom.css'

const heading = (classroom) => {
    return (<div style={{ display: 'flex', justifyContent: 'space-evenly' }} className="bg-info my-classroom-heading">
        <h3>{classroom.name}</h3>
        <h3>{classroom.room_ID}</h3>
        {/* <h3>{classroom.room_ID}</h3> */}
    </div>)
}

const MyClass = () => {
    const { id } = useParams()
    const { user } = useSelector((state) => ({ ...state }))
    const [loading, setLoading] = useState(true)
    const [active, setActive] = useState('messages')
    const [classroom, setClassroom] = useState({})

    useEffect(() => {
        loadclassroomDetails()
    }, [])

    const loadclassroomDetails = () => {
        getClassroomDetails(id)
            .then(res => {
                setClassroom(res.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                setLoading(false)
            })
    }

    const handleMessages = e => {
        e.preventDefault()
        setActive('messages')
    }

    const handleMeets = e => {
        e.preventDefault()
        setActive('meets')
    }

    const handleAssignments = e => {
        e.preventDefault()
        setActive('assignments')
    }

    const handlePeople = e => {
        e.preventDefault()
        setActive('people')
    }

    const switchDivs = () => {
        switch (active) {
            case 'people': return (<ClassPeople cid={id} user={user} students={classroom.students} teachers={classroom.teachers} />)
            case 'assignments': return (<ClassAssignments cid={id} user={user} />)
            case 'meets': return (<ClassMeets cid={id} user={user} />)
            default: return (<ClassMessages cid={id} user={user} />)
        }
    }

    return (
        <div className="my-classroom-div">
            {
                loading ? <h1>Loading</h1> : (
                    <>
                        {classroom ? heading(classroom) : ''}
                        <nav className="nav nav-pills flex-column flex-sm-row">
                            <button onClick={handleMessages} className={`flex-sm-fill text-sm-center nav-link ${active === 'messages' ? 'active' : ''}`}>Messages</button>
                            <button onClick={handleMeets} className={`flex-sm-fill text-sm-center nav-link ${active === 'meets' ? 'active' : ''}`}>Meetings</button>
                            <button onClick={handleAssignments} className={`flex-sm-fill text-sm-center nav-link ${active === 'assignments' ? 'active' : ''}`}>Assignments</button>
                            <button onClick={handlePeople} className={`flex-sm-fill text-sm-center nav-link ${active === 'people' ? 'active' : ''}`}>People</button>
                        </nav>
                        {switchDivs()}
                    </>
                )
            }
        </div>
    );
};

export default MyClass;